import React from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import { CssBaseline } from "@material-ui/core";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }
  body {
    background:
      radial-gradient(circle at top left, rgba(37, 99, 235, 0.22), transparent 32%),
      radial-gradient(circle at bottom right, rgba(15, 118, 110, 0.18), transparent 28%),
      linear-gradient(135deg, #f8fbff 0%, #eef4ff 42%, #f6faf8 100%);
  }
`;

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 32px 18px;
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 999px;
    filter: blur(10px);
    pointer-events: none;
  }

  &::before {
    width: 320px;
    height: 320px;
    top: -100px;
    left: -80px;
    background: rgba(59, 130, 246, 0.14);
  }

  &::after {
    width: 360px;
    height: 360px;
    right: -120px;
    bottom: -140px;
    background: rgba(13, 148, 136, 0.12);
  }
`;

const Shell = styled.div`
  width: min(1120px, 100%);
  position: relative;
  z-index: 1;
`;

const SignInLayout = ({ children }) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Shell>{children}</Shell>
    </Root>
  );
};

export default SignInLayout;
